import dialogs from '../helpers/registered-dialogs';

const getDialogByType = (modalType) => dialogs.get(modalType)?.Component;

export default getDialogByType;
